/** Ensures display names are unique within a workflow graph. */
export function allocateWorkflowNodeDisplayName(
  baseName: string,
  nodeId: string,
  usedNames: Set<string>
): string {
  if (!usedNames.has(baseName)) {
    usedNames.add(baseName);
    return baseName;
  }
  const disambiguated = `${baseName} (${nodeId.slice(0, 8)})`;
  if (!usedNames.has(disambiguated)) {
    usedNames.add(disambiguated);
    return disambiguated;
  }
  let suffix = 2;
  while (usedNames.has(`${disambiguated} ${suffix}`)) {
    suffix += 1;
  }
  const finalName = `${disambiguated} ${suffix}`;
  usedNames.add(finalName);
  return finalName;
}
